import React from 'react';
import { observer } from 'mobx-react';
import { Option, OptionWrapper, OwnerAvatar } from 'libs/forms/styles';
import { imageSrc } from 'apps/file/utils';
import { isTrialExpired } from 'utils/freeTrials';
import { conf as mainConf } from 'apps/config.yaml';

export const SpaceOption = observer(
  ({ app, highlighted, labelKey, onMouseOver, onClick, scrollRef }) => {
    const spaceType = app[labelKey].startsWith('@') ? 'Individual' : 'Team';
    const {
      hasPrivateProjectSubscription,
      trialPeriodEnd,
      hasValidPaymentMethod,
    } = app;

    const isPayingSubscription =
      (hasPrivateProjectSubscription &&
        trialPeriodEnd &&
        !isTrialExpired(trialPeriodEnd) &&
        hasValidPaymentMethod) ||
      hasPrivateProjectSubscription;

    const text =
      app.spaceType === 'INITIATIVE' && app.title ? app.title : app[labelKey];

    return (
      <OptionWrapper
        ref={scrollRef}
        highlighted={highlighted}
        onMouseOver={onMouseOver}
        onClick={onClick}
        data-testid={app[labelKey]}
      >
        <OwnerAvatar
          size='20px'
          src={imageSrc(
            app.content.avatar,
            app.content.imageFallbackPath,
            mainConf.imgSizes.profile.small,
          )}
        />
        <Option highlighted={highlighted}>
          {text}
          {isPayingSubscription ? ` (${spaceType} Subscription active)` : ''}
        </Option>
      </OptionWrapper>
    );
  },
);
